module.exports = __webpack_public_path__ + "media/applause10.0e462cf1.ogg";